import React from 'react';
import { C } from '../constants/design-tokens';

/** Position + chrome for inspector-style panels anchored in the right-stack
 *  slot (left of the RightBar). Shared by SettingsPanel's panel layout and
 *  EffectsPanel. */
export const inspectorPanelStyles: React.CSSProperties = {
  position: 'absolute',
  top: 16,
  right: 92,

  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: C.panelBg,
  color: C.textPrimary,
  border: `1px solid ${C.panelBorder}`,
  borderRadius: 14,
  boxShadow: '0 2px 20px rgba(0, 0, 0, 0.10)',
  zIndex: 10
};
